import { Appointment } from '../types';

type RebookStep = 1 | 2;

export function buildRebookBookingUrl(appointment: Appointment, step?: RebookStep): string | null {
  const businessShortName = appointment?.business_short_name;
  const assignments = Array.isArray(appointment?.assignments) ? appointment.assignments : [];

  if (!businessShortName || assignments.length === 0) return null;

  const serviceIds = assignments
    .map((a) => a?.serviceId)
    .filter((id): id is string => typeof id === 'string' && id.length > 0);

  if (serviceIds.length === 0) return null;

  // serviceId -> professionalId (if any)
  const professionalMap: Record<string, string> = {};
  for (const a of assignments) {
    if (a?.serviceId && a?.professionalId) {
      professionalMap[a.serviceId] = a.professionalId;
    }
  }

  const params = new URLSearchParams();
  params.set('rebook', 'true');
  if (step) params.set('step', String(step));
  params.set('serviceIds', serviceIds.join(','));

  Object.entries(professionalMap).forEach(([serviceId, professionalId]) => {
    params.append('professionalIds', `${serviceId}:${professionalId}`);
  });

  return `/${businessShortName}/booking?${params.toString()}`;
}

